'use strict';


export default function($http) {
	'ngInject';

	var vm = this;

	vm.userData = {};

	$http.get('/analytics/beta/').then(function(response) {
		vm.entityData = response.data;
	});

	vm.loadUser = function loadUser(user) {
		vm.activeUser = user;
		vm.activeUserData = {loading: true};
		if (vm.userData[user.uuid]) {
			vm.activeUserData = vm.userData[user.uuid];
		} else {
			$http.get('/analytics/beta/' + user.uuid + '/').then(function(response) {
				vm.userData[user.uuid] = response.data;
				vm.activeUserData = vm.userData[user.uuid];
			});
		}
	}

	vm.loadUserFromUUID = function loadUserFromUUID(users, uuid) {
		for (var i = 0; i < users.length; i++) {
			var user = users[i];
			if (user.uuid == uuid) {
				vm.loadUser(user);
				return;
			}
		}
	}
}
